module.exports = __webpack_public_path__ + "static/img/office_1.8b713b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_1.png
// module id = CEEu
// module chunks = 0